import { ReactComponent as ArrowDown } from './svg/arrowDown.svg'

export default ArrowDown
